module.exports = __webpack_public_path__ + "img/nocors.eddadc82.png";